import { render, staticRenderFns } from "./FumianpingjiaguanjianciDetail.vue?vue&type=template&id=65e20a50&scoped=true&"
import script from "./FumianpingjiaguanjianciDetail.vue?vue&type=script&lang=js&"
export * from "./FumianpingjiaguanjianciDetail.vue?vue&type=script&lang=js&"
import style0 from "./FumianpingjiaguanjianciDetail.vue?vue&type=style&index=0&id=65e20a50&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e20a50",
  null
  
)

export default component.exports